/* eslint-disable max-len */
import { CatalogTagsTranslation } from '../../common/libraries/modelViewer/Data/catalogTagsTranslation';
import { Strings } from './Strings';

export const getStaticTranslation = (tagsTranslation : CatalogTagsTranslation[] | undefined) : CatalogTagsTranslation[] => {
  if (tagsTranslation !== undefined) return tagsTranslation.filter((t) => t.option.startsWith('//$static/'));
  return new Array<CatalogTagsTranslation>();
};

export const getTranslatedStrings = (lang : string, orgStrings: Strings, tags : CatalogTagsTranslation[]) : Strings => {

  const newStrings : Strings = orgStrings;

  if (tags.length === 0) return newStrings;

  newStrings.BOOLEAN_ATTRIBUTE_YES = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('BOOLEAN_ATTRIBUTE_YES'))),
    lang,
  ) || orgStrings.BOOLEAN_ATTRIBUTE_YES || 'something went wrong...';

  newStrings.BOOLEAN_ATTRIBUTE_NO = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('BOOLEAN_ATTRIBUTE_NO'))),
    lang,
  ) || orgStrings.BOOLEAN_ATTRIBUTE_NO || 'something went wrong...';

  newStrings.PAGE_NOT_FOUND = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PAGE_NOT_FOUND'))),
    lang,
  ) || orgStrings.PAGE_NOT_FOUND || 'something went wrong...';

  newStrings.COLLECTIONS_HEADER_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('COLLECTIONS_HEADER_LABEL'))),
    lang,
  ) || orgStrings.COLLECTIONS_HEADER_LABEL || 'something went wrong...';

  newStrings.SEARCH_HEADER_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('SEARCH_HEADER_LABEL'))),
    lang,
  ) || orgStrings.SEARCH_HEADER_LABEL || 'something went wrong...';
  // SEARCH_HEADER_LABEL

  newStrings.INFORMATION_SLIDER_BUTTON = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('INFORMATION_SLIDER_BUTTON'))),
    lang,
  ) || orgStrings.INFORMATION_SLIDER_BUTTON || 'something went wrong...';
  // INFORMATION_SLIDER_BUTTON: '+ INFORMACIÓN',

  newStrings.NEXT_SLIDER_SPAN = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('NEXT_SLIDER_SPAN'))),
    lang,
  ) || orgStrings.NEXT_SLIDER_SPAN || 'something went wrong...';
  // NEXT_SLIDER_SPAN: 'Próxima',

  newStrings.PREVIOUS_SLIDER_SPAN = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PREVIOUS_SLIDER_SPAN'))),
    lang,
  ) || orgStrings.PREVIOUS_SLIDER_SPAN || 'something went wrong...';
  // PREVIOUS_SLIDER_SPAN: 'Previa',

  newStrings.SPOTLIGHT_OBJECTS_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('SPOTLIGHT_OBJECTS_LABEL'))),
    lang,
  ) || orgStrings.SPOTLIGHT_OBJECTS_LABEL || 'something went wrong...';
  // SPOTLIGHT_OBJECTS_LABEL: 'Botas de equitación a medida, fabricadas exclusivamente para usted.',

  newStrings.MENU_FOOTER_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('MENU_FOOTER_LABEL'))),
    lang,
  ) || orgStrings.MENU_FOOTER_LABEL || 'something went wrong...';
  // MENU_FOOTER_LABEL: 'Menú',

  newStrings.FILTERS_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('FILTERS_LABEL'))),
    lang,
  ) || orgStrings.FILTERS_LABEL || 'something went wrong...';
  // FILTERS_LABEL: 'Filtros',

  newStrings.VARIANTS_OBJECT_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('VARIANTS_OBJECT_LABEL'))),
    lang,
  ) || orgStrings.VARIANTS_OBJECT_LABEL || 'something went wrong...';
  // VARIANTS_OBJECT_LABEL: 'Variantes',

  newStrings.ADD_TO_CART_OBJECT_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ADD_TO_CART_OBJECT_LABEL'))),
    lang,
  ) || orgStrings.ADD_TO_CART_OBJECT_LABEL || 'something went wrong...';
  // ADD_TO_CART_OBJECT_LABEL: 'Añadir al carrito',

  newStrings.PRODUCT_LIST_ORDER_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCT_LIST_ORDER_LABEL'))),
    lang,
  ) || orgStrings.PRODUCT_LIST_ORDER_LABEL || 'something went wrong...';
  // PRODUCT_LIST_ORDER_LABEL: 'LISTA DE PRODUCTOS',

  newStrings.ORDER_TOTAL_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ORDER_TOTAL_LABEL'))),
    lang,
  ) || orgStrings.ORDER_TOTAL_LABEL || 'something went wrong...';
  // ORDER_TOTAL_LABEL: 'Total del carrito de compras',

  newStrings.CHECKOUT_ORDER_BUTTON = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CHECKOUT_ORDER_BUTTON'))),
    lang,
  ) || orgStrings.CHECKOUT_ORDER_BUTTON || 'something went wrong...';
  // CHECKOUT_ORDER_BUTTON: 'CONTINUAR A LA COMPROBACIÓN',

  newStrings.PREVIEW_ORDER_BUTTON = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PREVIEW_ORDER_BUTTON'))),
    lang,
  ) || orgStrings.PREVIEW_ORDER_BUTTON || 'something went wrong...';
  // PREVIEW_ORDER_BUTTON: 'Vista Previa del Pedido',

  newStrings.VARIANT_ORDER_ITEM_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('VARIANT_ORDER_ITEM_LABEL'))),
    lang,
  ) || orgStrings.VARIANT_ORDER_ITEM_LABEL || 'something went wrong...';
  // VARIANT_ORDER_ITEM_LABEL: 'Variante',

  newStrings.QUANTITY_ORDER_ITEM_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('QUANTITY_ORDER_ITEM_LABEL'))),
    lang,
  ) || orgStrings.QUANTITY_ORDER_ITEM_LABEL || 'something went wrong...';
  // QUANTITY_ORDER_ITEM_LABEL: 'Cantidad',

  newStrings.PRODUCT_ADDED_TOAST_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCT_ADDED_TOAST_LABEL'))),
    lang,
  ) || orgStrings.PRODUCT_ADDED_TOAST_LABEL || 'something went wrong...';
  // PRODUCT_ADDED_TOAST_LABEL: 'Producto añadido!',

  newStrings.CHECKOUT_ORDER_TOAST_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CHECKOUT_ORDER_TOAST_LABEL'))),
    lang,
  ) || orgStrings.CHECKOUT_ORDER_TOAST_LABEL || 'something went wrong...';
  // CHECKOUT_ORDER_TOAST_LABEL: '¡Solicitud enviada!',

  newStrings.COMPONENTS_OBJECT_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('COMPONENTS_OBJECT_LABEL'))),
    lang,
  ) || orgStrings.COMPONENTS_OBJECT_LABEL || 'something went wrong...';
  // COMPONENTS_OBJECT_LABEL: 'Componentes',

  newStrings.ORDER_DETAIL_TITLE_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ORDER_DETAIL_TITLE_LABEL'))),
    lang,
  ) || orgStrings.ORDER_DETAIL_TITLE_LABEL || 'something went wrong...';
  // ORDER_DETAIL_TITLE_LABEL: 'Detalle de la orden',

  newStrings.ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL'))),
    lang,
  ) || orgStrings.ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL || 'something went wrong...';
  // ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL: 'Atributos personalizados',

  newStrings.SUBMIT_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('SUBMIT_LABEL'))),
    lang,
  ) || orgStrings.SUBMIT_LABEL || 'something went wrong...';
  // SUBMIT_LABEL: 'Entregar',

  newStrings.ADD_TO_CART_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ADD_TO_CART_LABEL'))),
    lang,
  ) || orgStrings.ADD_TO_CART_LABEL || 'something went wrong...';
  // ADD_TO_CART_LABEL: 'Añadir artículo al carrito',

  newStrings.CUSTOMIZED_VARIANT = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CUSTOMIZED_VARIANT'))),
    lang,
  ) || orgStrings.CUSTOMIZED_VARIANT || 'something went wrong...';
  // CUSTOMIZED_VARIANT: 'Personalizada',

  newStrings.PRODUCTLIST = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCTLIST'))),
    lang,
  ) || orgStrings.PRODUCTLIST || 'something went wrong...';
  // PRODUCTLIST: 'Lista de productos',

  newStrings.PRODUCTLISTDOCLABEL_ITEMNAME = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCTLISTDOCLABEL_ITEMNAME'))),
    lang,
  ) || orgStrings.PRODUCTLISTDOCLABEL_ITEMNAME || 'something went wrong...';
  // PRODUCTLISTDOCLABEL_ITEMNAME: 'Nombre del árticulo',

  newStrings.PRODUCTLISTDOCLABEL_VARIATION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCTLISTDOCLABEL_VARIATION'))),
    lang,
  ) || orgStrings.PRODUCTLISTDOCLABEL_VARIATION || 'something went wrong...';
  // PRODUCTLISTDOCLABEL_VARIATION: 'Variación',

  newStrings.PRODUCTLISTDOCLABEL_COLLECTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCTLISTDOCLABEL_COLLECTION'))),
    lang,
  ) || orgStrings.PRODUCTLISTDOCLABEL_COLLECTION || 'something went wrong...';
  // PRODUCTLISTDOCLABEL_COLLECTION: 'Recopilación',

  newStrings.PRODUCTLISTDOCLABEL_COMPOSITION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCTLISTDOCLABEL_COMPOSITION'))),
    lang,
  ) || orgStrings.PRODUCTLISTDOCLABEL_COMPOSITION || 'something went wrong...';
  // PRODUCTLISTDOCLABEL_COMPOSITION: 'Composición',

  newStrings.PRODUCTLISTDOCLABEL_QUANTITY = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRODUCTLISTDOCLABEL_QUANTITY'))),
    lang,
  ) || orgStrings.PRODUCTLISTDOCLABEL_QUANTITY || 'something went wrong...';
  // PRODUCTLISTDOCLABEL_QUANTITY: 'Cantidad',

  newStrings.NAVIGATE_BACK = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('NAVIGATE_BACK'))),
    lang,
  ) || orgStrings.NAVIGATE_BACK || 'something went wrong...';
  // NAVIGATE_BACK: 'Regresa',

  newStrings.REMOVE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REMOVE'))),
    lang,
  ) || orgStrings.REMOVE || 'something went wrong...';
  // REMOVE: 'Eliminar',

  newStrings.CLEAR_CART = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CLEAR_CART'))),
    lang,
  ) || orgStrings.CLEAR_CART || 'something went wrong...';
  // CLEAR_CART: 'Vaciar carrito',

  newStrings.RESULTS_FOR = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('RESULTS_FOR'))),
    lang,
  ) || orgStrings.RESULTS_FOR || 'something went wrong...';
  // RESULTS_FOR: 'resultados para',

  newStrings.NO_CONTENT_TEXT = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('NO_CONTENT_TEXT'))),
    lang,
  ) || orgStrings.NO_CONTENT_TEXT || 'something went wrong...';
  // NO_CONTENT_TEXT: 'Imagen no disponible',

  newStrings.STANDARD = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('STANDARD'))),
    lang,
  ) || orgStrings.STANDARD || 'something went wrong...';
  // STANDARD: 'Estándar',

  newStrings.PARTS = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PARTS'))),
    lang,
  ) || orgStrings.PARTS || 'something went wrong...';
  // PARTS: 'Partes',

  newStrings.CUSTOMIZATIONS = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CUSTOMIZATIONS'))),
    lang,
  ) || orgStrings.COLLECTIONS_HEADER_LABEL || 'something went wrong...';
  // CUSTOMIZATIONS: 'Personalizaciones',

  newStrings.PRICE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('PRICE'))),
    lang,
  ) || orgStrings.PRICE || 'something went wrong...';
  // PRICE: 'Precio',

  newStrings.TOTAL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('TOTAL'))),
    lang,
  ) || orgStrings.TOTAL || 'something went wrong...';
  // TOTAL: 'Total',

  newStrings.QUANTITY = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('QUANTITY'))),
    lang,
  ) || orgStrings.QUANTITY || 'something went wrong...';
  // QUANTITY: 'Cantidad',

  newStrings.MEASURES = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('MEASURES'))),
    lang,
  ) || orgStrings.MEASURES || 'something went wrong...';
  // MEASURES: 'Medidas',

  newStrings.CUSTOM_ATTRIBUTES = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CUSTOM_ATTRIBUTES'))),
    lang,
  ) || orgStrings.CUSTOM_ATTRIBUTES || 'something went wrong...';
  // CUSTOM_ATTRIBUTES: 'Atributos personalizados',

  newStrings.LOGIN_SUCCESSFUL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_SUCCESSFUL'))),
    lang,
  ) || orgStrings.LOGIN_SUCCESSFUL || 'something went wrong...';
  // LOGIN_SUCCESSFUL: 'Inicio de sesión exitosa',

  newStrings.LOGIN_CREDENTIALS_NOT_VALID = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_CREDENTIALS_NOT_VALID'))),
    lang,
  ) || orgStrings.LOGIN_CREDENTIALS_NOT_VALID || 'something went wrong...';
  // LOGIN_CREDENTIALS_NOT_VALID: 'Credenciales no válidas',

  newStrings.LOGIN_UNKNOWN_ERROR = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_UNKNOWN_ERROR'))),
    lang,
  ) || orgStrings.LOGIN_UNKNOWN_ERROR || 'something went wrong...';
  // LOGIN_UNKNOWN_ERROR: 'Error desconocido',

  newStrings.LOGIN_RECOVER_PASSWORD = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_RECOVER_PASSWORD'))),
    lang,
  ) || orgStrings.LOGIN_RECOVER_PASSWORD || 'something went wrong...';
  // LOGIN_RECOVER_PASSWORD: 'Recuperar contraseña',

  newStrings.LOGIN_CHANGE_PASSWORD = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_CHANGE_PASSWORD'))),
    lang,
  ) || orgStrings.LOGIN_CHANGE_PASSWORD || 'something went wrong...';
  // LOGIN_CHANGE_PASSWORD: 'Cambiar la contraseña',

  newStrings.LOGIN_USERNAME = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_USERNAME'))),
    lang,
  ) || orgStrings.LOGIN_USERNAME || 'something went wrong...';
  //  LOGIN_USERNAME: 'Nombre de usuario',

  newStrings.LOGIN_PASSWORD = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_PASSWORD'))),
    lang,
  ) || orgStrings.LOGIN_PASSWORD || 'something went wrong...';
  // LOGIN_PASSWORD: 'Contraseña',

  newStrings.LOGIN_OLD_PASSWORD = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_OLD_PASSWORD'))),
    lang,
  ) || orgStrings.LOGIN_OLD_PASSWORD || 'something went wrong...';
  // LOGIN_OLD_PASSWORD: 'Contraseña anterior',

  newStrings.LOGIN_NEW_PASSWORD = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_NEW_PASSWORD'))),
    lang,
  ) || orgStrings.LOGIN_NEW_PASSWORD || 'something went wrong...';
  // LOGIN_NEW_PASSWORD: 'Nueva contraseña',

  newStrings.LOGIN_NEW_PASSWORD_REPEAT = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_NEW_PASSWORD_REPEAT'))),
    lang,
  ) || orgStrings.LOGIN_NEW_PASSWORD_REPEAT || 'something went wrong...';
  // LOGIN_NEW_PASSWORD_REPEAT: 'repita la nueva contraseña',

  newStrings.LOGIN_ACTION_LOGIN = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('LOGIN_ACTION_LOGIN'))),
    lang,
  ) || orgStrings.LOGIN_ACTION_LOGIN || 'something went wrong...';
  // LOGIN_ACTION_LOGIN: 'Acceso',

  newStrings.RECOVER_PASSWORD_MESSAGE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('RECOVER_PASSWORD_MESSAGE'))),
    lang,
  ) || orgStrings.RECOVER_PASSWORD_MESSAGE || 'something went wrong...';
  // RECOVER_PASSWORD_MESSAGE: 'Se ha enviado una nueva contraseña a su correo electrónico.',

  newStrings.CHANGE_PASSWORD_SUCCESSFUL_MESSAGE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CHANGE_PASSWORD_SUCCESSFUL_MESSAGE'))),
    lang,
  ) || orgStrings.CHANGE_PASSWORD_SUCCESSFUL_MESSAGE || 'something went wrong...';
  // CHANGE_PASSWORD_SUCCESSFUL_MESSAGE: 'El cambio de contraseña fue exitoso.',

  newStrings.CHANGE_PASSWORD_ERROR_MESSAGE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CHANGE_PASSWORD_ERROR_MESSAGE'))),
    lang,
  ) || orgStrings.CHANGE_PASSWORD_ERROR_MESSAGE || 'something went wrong...';
  // CHANGE_PASSWORD_ERROR_MESSAGE: 'Se produjo un error al intentar cambiar la contraseña.',

  newStrings.CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE'))),
    lang,
  ) || orgStrings.CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE || 'something went wrong...';
  // CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE: 'La nueva contraseña debe coincidir con la nueva contraseña repetida.',

  newStrings.GO_BACK_ACTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('GO_BACK_ACTION'))),
    lang,
  ) || orgStrings.GO_BACK_ACTION || 'something went wrong...';
  // GO_BACK_ACTION: 'Atrás',

  newStrings.CONFIRM_ACTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CONFIRM_ACTION'))),
    lang,
  ) || orgStrings.CONFIRM_ACTION || 'something went wrong...';
  // CONFIRM_ACTION: 'Confirmar',

  newStrings.SIGN_OUT_ACTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('SIGN_OUT_ACTION'))),
    lang,
  ) || orgStrings.SIGN_OUT_ACTION || 'something went wrong...';
  // SIGN_OUT_ACTION: 'Desconectar',

  newStrings.OK_ACTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('OK_ACTION'))),
    lang,
  ) || orgStrings.OK_ACTION || 'something went wrong...';
  // OK_ACTION: 'De acuerdo',

  newStrings.CANCEL_ACTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('CANCEL_ACTION'))),
    lang,
  ) || orgStrings.CANCEL_ACTION || 'something went wrong...';
  // CANCEL_ACTION: 'Cancelar',

  newStrings.RETRY_ACTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('RETRY_ACTION'))),
    lang,
  ) || orgStrings.RETRY_ACTION || 'something went wrong...';
  // RETRY_ACTION: 'Rever',

  newStrings.RESEND_ACTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('RESEND_ACTION'))),
    lang,
  ) || orgStrings.RESEND_ACTION || 'something went wrong...';
  // RESEND_ACTION: 'Reenviar',

  newStrings.ERROR_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ERROR_LABEL'))),
    lang,
  ) || orgStrings.ERROR_LABEL || 'something went wrong...';
  // ERROR_LABEL: 'Error',

  newStrings.SUCCESS_LABEL = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('SUCCESS_LABEL'))),
    lang,
  ) || orgStrings.SUCCESS_LABEL || 'something went wrong...';
  // SUCCESS_LABEL: 'Éxito',

  newStrings.ORDER_ERROR_MESSAGE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ORDER_ERROR_MESSAGE'))),
    lang,
  ) || orgStrings.ORDER_ERROR_MESSAGE || 'something went wrong...';
  // ORDER_ERROR_MESSAGE: 'Se produjo un error al intentar enviar el pedido.',

  newStrings.ORDER_SUCCESS_MESSAGE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('ORDER_SUCCESS_MESSAGE'))),
    lang,
  ) || orgStrings.ORDER_SUCCESS_MESSAGE || 'something went wrong...';
  // ORDER_SUCCESS_MESSAGE: 'El envío del pedido fue exitoso.',

  newStrings.VALIDATION_POP_UP_TITLE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('VALIDATION_POP_UP_TITLE'))),
    lang,
  ) || orgStrings.VALIDATION_POP_UP_TITLE || 'something went wrong...';
  // VALIDATION_POP_UP_TITLE: 'Validación de correo electrónico',

  newStrings.VALIDATION_POP_UP_MESSAGE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('VALIDATION_POP_UP_MESSAGE'))),
    lang,
  ) || orgStrings.VALIDATION_POP_UP_MESSAGE || 'something went wrong...';
  // VALIDATION_POP_UP_MESSAGE: 'Por favor inserte el código enviado a su correo electrónico:',

  newStrings.VALIDATION_POP_UP_ERROR = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('VALIDATION_POP_UP_ERROR'))),
    lang,
  ) || orgStrings.VALIDATION_POP_UP_ERROR || 'something went wrong...';
  // VALIDATION_POP_UP_ERROR: 'El código no coincide',

  newStrings.REPORT_ORDER_INFO_TITLE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REPORT_ORDER_INFO_TITLE'))),
    lang,
  ) || orgStrings.REPORT_ORDER_INFO_TITLE || 'something went wrong...';

  newStrings.REPORT_TITLE_DESCRIPTION = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REPORT_TITLE_DESCRIPTION'))),
    lang,
  ) || orgStrings.REPORT_TITLE_DESCRIPTION || 'something went wrong...';

  newStrings.REPORT_TITLE_VALUE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REPORT_TITLE_VALUE'))),
    lang,
  ) || orgStrings.REPORT_TITLE_VALUE || 'something went wrong...';

  newStrings.REPORT_TITLE_QUANTITY = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REPORT_TITLE_QUANTITY'))),
    lang,
  ) || orgStrings.REPORT_TITLE_QUANTITY || 'something went wrong...';

  newStrings.REPORT_TITLE_PRICE = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REPORT_TITLE_PRICE'))),
    lang,
  ) || orgStrings.REPORT_TITLE_PRICE || 'something went wrong...';

  newStrings.REPORT_TITLE_SCREENSHOT = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REPORT_TITLE_SCREENSHOT'))),
    lang,
  ) || orgStrings.REPORT_TITLE_SCREENSHOT || 'something went wrong...';

  newStrings.REPORT_TITLE_KEY = CatalogTagsTranslation.getTranslation(
    tags.find((t) => !t.option.localeCompare(CatalogTagsTranslation.getStatictringKey('REPORT_TITLE_KEY'))),
    lang,
  ) || orgStrings.REPORT_TITLE_KEY || 'something went wrong...';

  return newStrings;
};
